import { render, staticRenderFns } from "./UcJobNameBadge.yaml?vue&type=template&id=3f5a7dca&component"
import script from "./UcJobNameBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcJobNameBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports